<template>
    <div>

        <mu-paper :z-depth="1" class="item-group" v-if="item">
            <div class="details">
                <mu-row justify-content="center" align-items="center">
                    <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                        <h3>
                            <router-link :to="{ name: 'app.contacts.groups.edit', params: { id: item.id } }">
                                {{ item.name }}
                            </router-link>
                        </h3>
                    </mu-col>
                    <mu-col span="4" sm="2" md="2" lg="2" xl="2" class="is-center">
                        <span class="uppercase" v-if="!item.iseditable">
                            <font-awesome-icon icon="share-alt" class="icon-md icon-margin-left"/>
                            Compartilharam com você
                        </span>
                        <span class="uppercase" v-else-if="item.shared">
                            <font-awesome-icon icon="share-alt" class="icon-md icon-margin-left"/>
                            Você compartilhou
                        </span>
                    </mu-col>
                    <mu-col span="4" sm="2" md="2" lg="2" xl="2" class="is-center">
                        <span class="number" v-if="item.totalcontacts > 0">{{ item.totalcontacts }}</span>
                        <span class="uppercase" v-else>{{ item.totalcontacts }}</span><br>
                        <span class="uppercase">Contatos</span>
                    </mu-col>
                    <mu-col span="4" sm="2" md="2" lg="2" xl="2" class="is-center">
                        <a href="javascript:;" @click="loadSubgroups()" class="link-subgroups" v-if="item.totalsubgroups > 0">
                            <span class="number">{{ item.totalsubgroups }}</span><br>
                            <span class="uppercase">
                                Subgrupos
                                <font-awesome-icon v-if="!subgroups.visible" icon="arrow-down" class="icon-sm icon-margin-left"/>
                                <font-awesome-icon v-if="subgroups.visible" icon="arrow-up" class="icon-sm icon-margin-left"/>
                            </span>
                        </a>
                    </mu-col>
                </mu-row>
            </div>
            <div class="subgroups" v-if="subgroups.visible">
                <table class="table mu-table-custom" v-if="subgroups.list.length > 0">
                    <thead>
                        <tr>
                            <th>Subgrupo</th>
                            <th class="is-center" width="120">Contatos</th>
                            <th class="is-center" width="120">Editar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(i, k) in subgroups.list" :key="k">
                            <td>{{ i.name }}</td>
                            <td class="is-center">{{ i.totalcontacts }}</td>
                            <td class="is-center">
                                <router-link :to="{ name: 'app.contacts.groups.edit', params: { id: i.id } }">
                                    <font-awesome-icon icon="pen" class="icon-md icon-margin-right"/>
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="empty">Nenhum subgrupo para o grupo <strong>{{ item.name }}</strong></div>
                <mu-loading text="Carregando a lista de subgrupos" v-if="subgroups.loading"></mu-loading>
            </div>
        </mu-paper>

    </div>
</template>

<script>
    import GroupsServices from '@/services/contacts/groups'

    export default {
        name: 'item-group',
        props: ['item'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                subgroups: {
                    visible: false,
                    loading: false,
                    list: []
                }
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            async loadSubgroups () {
                try {
                    this.subgroups.visible = !this.subgroups.visible
                    if (!this.subgroups.visible) {
                        return
                    }
                    this.subgroups.loading = true
                    let result = await GroupsServices.findAllSubgroups(this.item.id)
                    if (result && result.status) {
                        this.subgroups.list = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os subgrupos.')
                } finally {
                    this.subgroups.loading = false
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .item-group
        margin-bottom 15px

        .details
            padding 10px 15px
            a
                text-decoration none
                &:hover
                    color $primary
                span.uppercase
                    border-bottom 1px #ccc solid
            h3
                margin 0
                color $secondary
            span
                color #999
                font-size 12px
            span.uppercase
                text-transform uppercase
                font-size 11px
                i
                    font-size 12px
            span.number
                font-size 16px
                font-weight bold
                margin-right 3px
            .link-subgroups
                span
                    color $primary
                    &.uppercase
                        border-bottom 1px $primary solid

        .subgroups
            border-top 1px #ccc solid
            max-height 200px
            overflow hidden
            overflow-y scroll
            background #fafafa

            .empty
                text-align center
                padding 10px 0

            table.table
                width 100%
                border-collapse collapse
                th
                    background #e0e0e0
                th, td
                    padding 4px 15px
                    text-align left
                    border-bottom 1px #ccc solid
                tr
                    &:hover
                        td
                            background #eeeeee

                .is-center
                    text-align center

</style>
